'use client';

const FBCLID_KEY = 'fbclid';

const FBCLID_LIFETIME_MS = 7 * 24 * 60 * 60 * 1000;

interface StoredFbclid {
  value: string;
  expiresAt: number;
}

function readStoredFbclid(): StoredFbclid | null {
  try {
    const raw = localStorage.getItem(FBCLID_KEY);

    if (!raw) {
      return null;
    }

    const stored = JSON.parse(raw) as StoredFbclid;

    return typeof stored?.value === 'string' && typeof stored?.expiresAt === 'number'
      ? stored
      : null;
  } catch {
    return null;
  }
}

function persistFbclid(value: string): void {
  try {
    localStorage.setItem(
      FBCLID_KEY,
      JSON.stringify({ value, expiresAt: Date.now() + FBCLID_LIFETIME_MS }),
    );
  } catch {
    return;
  }
}

function clearFbclid(): void {
  try {
    localStorage.removeItem(FBCLID_KEY);
  } catch {
    return;
  }
}

export function resolveFbclid(fbclidFromUrl: string | null): string | undefined {
  if (fbclidFromUrl) {
    persistFbclid(fbclidFromUrl);

    return fbclidFromUrl;
  }

  const stored = readStoredFbclid();

  if (!stored) {
    return undefined;
  }

  if (Date.now() > stored.expiresAt) {
    clearFbclid();

    return undefined;
  }

  return stored.value;
}
